import { BaseToast } from "react-native-toast-message";

const toastConfig = {
  error: ({ text1, text2, ...rest }) => (
    <BaseToast
      {...rest}
      style={{ borderLeftColor: "red", height: "auto", minHeight: 60 }}
      contentContainerStyle={{ paddingHorizontal: 15, paddingVertical: 10 }}
      text1NumberOfLines={0}
      text2NumberOfLines={0}
      text1Style={{
        fontSize: 18, // Aumenta o tamanho da fonte do título
        fontWeight: "medium",
      }}
      text2Style={{
        fontSize: 16, // Aumenta o tamanho da fonte da mensagem
        color: "black",
        opacity: 0.7,
      }}
      text1={text1}
      text2={text2}
    />
  ),
  success: ({ text1, text2, ...rest }) => (
    <BaseToast
      {...rest}
      style={{ borderLeftColor: "green", height: "auto", minHeight: 60 }}
      contentContainerStyle={{ paddingHorizontal: 15, paddingVertical: 10 }}
      text1NumberOfLines={0}
      text2NumberOfLines={0}
      text1Style={{
        fontSize: 18, // Aumenta o tamanho da fonte do título
        fontWeight: "medium",
      }}
      text2Style={{
        fontSize: 16, // Aumenta o tamanho da fonte da mensagem
        color: "black",
        opacity: 0.7,
      }}
      text1={text1}
      text2={text2}
    />
  ),
};

export default toastConfig;
